import { StoreLocatorCardList } from "@locators/components/shared/components/StoreLocatorCardList";
import { StoreLocatorMap } from "@locators/components/shared/components/StoreLocatorMap";
import { useStoreLocatorContext } from "@locators/components/shared/hooks";
import { useDisplayType } from "@locators/components/shared/hooks/useDisplayType";
import type { MobileDisplayType } from "@locators/components/shared/types";
import classNames from "classnames";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { StoreLocatorMobileInfoContainer } from "../StoreLocatorMobileInfoContainer";
import { StoreLocatorSearchBar } from "../StoreLocatorSearchBar";

import styles from "./StoreLocatorV1.module.scss";

export const StoreLocatorV1 = () => {
  const { __ } = useTranslations();

  const { change, isMap } = useDisplayType("map");

  const onChangeResultType = (type: MobileDisplayType) => {
    change(flotiqStores.length > 0 ? type : "map");
  };

  const { flotiqStores, isNoMatchingFlotiqStores } = useStoreLocatorContext();

  return (
    <div
      className={styles.mainContainer}
      translate="no" // disabling browser translation of the child elements as it breaks the page on mount/unmount of filters
    >
      <StoreLocatorSearchBar />
      <StoreLocatorMobileInfoContainer onChangeResultType={onChangeResultType} />
      {isNoMatchingFlotiqStores && (
        <div className={styles.warningMessage}>
          <AlertBanner
            tone="warning"
            description={__("cart.checkout.delivery.in_store.attributes_filtering.no_matches_found")}
          />
        </div>
      )}
      <div className={styles.resultsContainer}>
        <StoreLocatorCardList isMapView={isMap} />
        <div
          className={classNames(styles.mapContainer, {
            [styles.mapContainerHidden]: !isMap,
          })}
        >
          <StoreLocatorMap className={styles.mapWrapper} mapClassName={styles.map} />
        </div>
      </div>
    </div>
  );
};
